export default "__VITE_ASSET__DgbRABii__"